import React from "react";
import { Group, Modal, Stack, Text } from "@mantine/core";
import { Button } from "@xplatform/design-system";
import { IconRefresh } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export interface ConflictModalProps {
  opened: boolean;
  /** The 409 `error_code` (revision_conflict, active_changed, not_a_draft, ...). */
  code: string | null;
  onReload: () => void;
  onClose: () => void;
}

/** Someone else changed the draft or the active version: reload; unsaved edits stay in memory. */
export const ConflictModal: React.FC<ConflictModalProps> = ({ opened, code, onReload, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal opened={opened} onClose={onClose} title={t("mappingConfig.conflict.title")}
           portalProps={{ target: "#admin-portal-root" }}>
      <Stack gap="md">
        <Text size="sm">
          {t(`mappingConfig.conflict.${code ?? "generic"}`, { defaultValue: t("mappingConfig.conflict.generic") })}
        </Text>
        <Text size="xs" c="dimmed">{t("mappingConfig.conflict.keepHint")}</Text>
        <Group justify="flex-end" gap="sm">
          <Button variant="default" onClick={onClose}>{t("common.cancel")}</Button>
          <Button leftSection={<IconRefresh size={16} />} onClick={onReload}>{t("mappingConfig.conflict.reload")}</Button>
        </Group>
      </Stack>
    </Modal>
  );
};
